import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { hasIn } from 'lodash';

@Injectable()
export class HttpOxioNamespaceInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersConfig = {};

    if (hasIn(APP_ENV, 'OXIO_NAMESPACE')) {
      headersConfig['oxio-namespace'] = APP_ENV.OXIO_NAMESPACE;
    }
    
    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request);
  }
}
